import { Permissions, useAuthWrapper } from '@weareopenr/authkit';

/**
 * Custom hook that provides permission checks for various application features
 * @returns Object containing boolean permission flags
 */
export const usePermissions = () => {
  const { hasPermission, hasAllPermissions } = useAuthWrapper();

  const canViewUsersAndRoles = hasAllPermissions([Permissions.USERS_READ, Permissions.ROLES_READ]);
  const canCreateUsers = hasPermission(Permissions.USERS_CREATE);
  const canEditUsers = hasPermission(Permissions.USERS_UPDATE);
  const canDeactivateUsers = hasPermission(Permissions.USERS_UPDATE);
  const canViewRoles = hasPermission(Permissions.ROLES_READ);
  const canCreateBrands = hasPermission(Permissions.BRANDS_CREATE);
  const canEditBrands = hasPermission(Permissions.BRANDS_UPDATE);
  const canDeleteBrands = hasPermission(Permissions.BRANDS_DELETE);
  const canInstallExtensions = hasPermission(Permissions.EXTENSIONS_INSTALL);
  const canEditExtensions = hasPermission(Permissions.EXTENSIONS_UPDATE);
  const canUninstallExtensions = hasPermission(Permissions.EXTENSIONS_UNINSTALL);

  return {
    canCreateBrands,
    canEditBrands,
    canDeleteBrands,
    canViewUsersAndRoles,
    canCreateUsers,
    canEditUsers,
    canDeactivateUsers,
    canViewRoles,
    canInstallExtensions,
    canEditExtensions,
    canUninstallExtensions,
  };
};
